import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { EnvironmentTypes } from 'shared/constants/environmentTypes';
import { permissionsTypes } from 'shared/constants/permissionsTypes';
import { licencesTypes } from 'shared/constants/licencesTypes';
import { allStandardRolesTypes, organisationAdmin } from 'shared/constants/rolesTypes';
import { mergePermissionsParser, validateRoles } from 'shared/parsers';
import { validateShopPermissions } from 'modules/shop/shared/parsers';
import { useHubSpot } from 'shared/hooks';

import { store } from 'store/store';

const PrivateRoute = ({
  component: Component,
  environment,
  permission,
  licence,
  role,
  shopPermissions: shopRoles,
  ...rest
}) => {
  useHubSpot();
  const { permissions, licences, roles, shopPermissions } = store.getState().auth.data;

  const mergedPermissions = permissions ? mergePermissionsParser(permissions) : [];

  const checkEnvironment = environment ? environment === process.env.NODE_ENV : true;
  const checkPermission = permission ? mergedPermissions.includes(permission) : true;
  const checkLicence = licence ? licences.includes(licence) : true;
  const checkRole = role ? validateRoles(roles, role) : true;
  const checkShopPermissions =
    shopRoles && shopRoles.length ? validateShopPermissions(shopPermissions, shopRoles) : true;

  return checkEnvironment &&
    checkPermission &&
    checkLicence &&
    checkRole &&
    checkShopPermissions ? (
    <Component {...rest} />
  ) : (
    <Navigate to={{ pathname: '/not-found' }} />
  );
};

PrivateRoute.defaultProps = {
  environment: null,
  permission: null,
  licence: null,
  role: null,
  shopPermissions: [],
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  environment: PropTypes.oneOf([...Object.values(EnvironmentTypes), null]),
  permission: PropTypes.oneOf([...Object.keys(permissionsTypes), null]),
  licence: PropTypes.oneOf([...Object.keys(licencesTypes), null]),
  role: PropTypes.oneOf([...allStandardRolesTypes, allStandardRolesTypes, organisationAdmin, null]),
  shopPermissions: PropTypes.arrayOf(PropTypes.string),
};

export { PrivateRoute };
